import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Loader from "../../components/shared/Loader";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

const SeoRedirectsIndex = () => {
	const [redirects, setRedirects] = useState([]);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "عناصر اعادة التوجيه",
				breadcrumb: "اعادة التوجيه",
				button: {
					show: true,
					text: "اضافة عنصر اعادة توجيه",
					link: "/seoRedirects/create",
				},
			})
		);

		axios
			.get(`${process.env.REACT_APP_API_URL}/seoRedirects`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setRedirects(response.data.data.seoRedirects || response.data.data || []);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
				setLoading(false);
			});
	};

	const handleConfirmDelete = id => {
		confirmAlert({
			title: "تأكيد الحذف",
			message: "هل أنت متأكد من رغبتك في حذف رابط اعادة التوجيه؟",
			buttons: [
				{
					label: "نعم",
					onClick: () => deleteRedirect(id),
				},
				{
					label: "لا",
					onClick: () => {},
				},
			],
		});
	};

	const deleteRedirect = id => {
		axios
			.delete(`${process.env.REACT_APP_API_URL}/seoRedirects/${id}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function () {
				toast.success("تم الحذف بنجاح!");
				onStart();
			})
			.catch(function () {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const columns = [
		{
			name: "المصدر",
			selector: "source",
			sortable: true,
			cell: row => (
				<div
					style={{ maxWidth: "35vw", overflow: "hidden", direction: "ltr" }}
					title={row.source}
				>
					{row.source}
				</div>
			),
		},
		{
			name: "الهدف",
			selector: "destination",
			sortable: true,
			cell: row => (
				<div
					style={{ maxWidth: "35vw", overflow: "hidden", direction: "ltr" }}
					title={row.destination}
				>
					{row.destination}
				</div>
			),
		},
		{
			name: "كود اعادة التوجيه",
			selector: "redirectCode",
			sortable: true,
		},
		{
			name: "",
			selector: "settings",
			cell: row => (
				<ul className="list-inline settingsList">
					<li className="list-inline-item">
						<Link
							className="bt bt-sm bt-success"
							to={`/seoRedirects/show/${row._id || row.id}`}
						>
							<i className="fas fa-edit"></i>
						</Link>
					</li>
					<li className="list-inline-item">
						<button
							className="bt bt-sm bt-danger"
							onClick={() => handleConfirmDelete(row._id || row.id)}
						>
							<i className="fas fa-trash"></i>
						</button>
					</li>
				</ul>
			),
		},
	];

	return (
		<section>
			{loading && <Loader />}
			<div className="datatable">
				<DataTableExtensions columns={columns} data={redirects}>
					<DataTable
						noHeader
						defaultSortField="id"
						defaultSortAsc={false}
						pagination
						highlightOnHover
						direction="rtl"
						striped
					/>
				</DataTableExtensions>
			</div>
		</section>
	);
};

export default SeoRedirectsIndex;
